module.exports = __webpack_public_path__ + "./images/tier7.jpg";